import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';
import { ca } from 'date-fns/locale';

const ENDPOINT = '/carrion';

export class CarrionService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE CARROÑAS
     * @EN GETS THE LIST OF CARRIONS
     */
    // -------------------------------------------------------------------------------------------------------------
    listCarrions = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA CARROÑA POR SU ID
     * @EN GETS A CARRION BY ITS ID
     * 
     * @param carrionId
     */
    // -------------------------------------------------------------------------------------------------------------
    getCarrionById = async (carrionId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id : carrionId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE EL NÚMERO TOTAL DE CARROÑAS
     * @EN GETS THE TOTAL NUMBER OF CARRIONS
     */
    // -------------------------------------------------------------------------------------------------------------
    getTotalCarrions = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-carrions-total-by-state',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA CARROÑA
     * @EN CREATES A CARRION
     * 
     * @param carrion
     */
    // -------------------------------------------------------------------------------------------------------------
    createCarrion = async (carrion: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: carrion,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    importCarrions = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UNA CARROÑA
     * @EN UPDATES A CARRION
     * 
     * @param carrion
     */
    // -------------------------------------------------------------------------------------------------------------
    editCarrion = async (carrion: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: carrion,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA CARROÑA
     * @EN DELETES A CARRION
     * 
     * @param carrionId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteCarrions = async (carrionId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: carrionId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS CARROÑAS
     * @EN DELETES MULTIPLE CARRIONS
     * 
     * @param carrionIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiCarrions = async (carrionIds: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { carrionIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE CARROÑAS
     * @EN GETS THE LIST OF CARRION STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listStatusCarrion = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UNA CARROÑA
     * @EN CHANGES THE STATE OF A CARRION
     * 
     * @param carrionId
     * @param statusId
     */
    // -------------------------------------------------------------------------------------------------------------
    changeStatusCarrion = async (carrionId: string, statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: { 
                id: carrionId,
                statusId: statusId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE CARROÑAS
     * @EN GETS THE LIST OF CARRION STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelectStatus = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES VALIDA VARIAS CARROÑAS
     * @EN VALIDATES MULTIPLE CARRIONS
     * 
     * @param carrionIds
     */
    // -------------------------------------------------------------------------------------------------------------
    validateSelectedCarrions = async (carrionIds: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/validate-multiple',
            data: { ids : carrionIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}
